import { ReactNode } from 'react';

import { ISort } from '@t/api/common';

import { TableContext } from 'components/table/context/table.context';
import { useTableStore } from 'components/table/hooks/context/store.hook';

const TableProvider = <TData = unknown,>({ children, sorts }: { children: ReactNode; sorts?: ISort<TData>[] }) => {
  return <TableContext.Provider value={useTableStore(sorts)}>{children}</TableContext.Provider>;
};

export default TableProvider;
